import type { AreaRelatorio, RelatorioGestao } from './schemas';

function timestamp(report: RelatorioGestao) {
  const created = Date.parse(report.criado_em);
  if (!Number.isNaN(created)) return created;
  const base = Date.parse(report.data_base);
  return Number.isNaN(base) ? 0 : base;
}

function normalizedTitle(report: RelatorioGestao) {
  return report.titulo
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

function reportCategory(report: RelatorioGestao) {
  if (report.area !== 'credito') return 'area';
  const title = normalizedTitle(report);
  return title.includes('liberacao') || title.includes('liberacoes')
    ? 'credito-liberacoes'
    : 'credito-cards';
}

export function splitAreaReports(reports: RelatorioGestao[], area: AreaRelatorio) {
  const ordered = reports
    .filter((report) => report.area === area)
    .sort((a, b) => timestamp(b) - timestamp(a));

  const latestByCategory = new Map<string, RelatorioGestao>();
  for (const report of ordered) {
    const category = reportCategory(report);
    if (!latestByCategory.has(category)) latestByCategory.set(category, report);
  }

  const latestIds = new Set([...latestByCategory.values()].map((report) => report.id));

  return {
    latest: ordered.filter((report) => latestIds.has(report.id)),
    history: ordered.filter((report) => !latestIds.has(report.id)),
  };
}
